import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { purchaseRequestsService, offersService } from '../../../services/supabaseService';
import CreateRequestForm from '../../buyer-dashboard/components/CreateRequestForm';
import RequestsTable from '../../buyer-dashboard/components/RequestsTable';
import OffersPanel from '../../buyer-dashboard/components/OffersPanel';
import FilterBar from '../../buyer-dashboard/components/FilterBar';

const BuyerMode = ({ data, onRefresh, currentLanguage }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [filters, setFilters] = useState({ status: '', category: '', destination: '' });
  const [selectedRequestId, setSelectedRequestId] = useState(null);

  const handleCreateRequest = async (formData) => {
    try {
      const categoryMap = {
        'electronics': 'electronics',
        'fashion': 'fashion',
        'cosmetics': 'cosmetics',
        'food': 'food',
        'books': 'books',
        'sports': 'sports',
        'toys': 'toys',
        'health': 'health'
      };

      const newRequest = {
        buyerId: user?.id,
        itemName: formData?.itemName,
        category: categoryMap?.[formData?.category] || 'electronics',
        originCountry: formData?.originCountry,
        destinationCountry: formData?.destinationCountry,
        budget: parseInt(formData?.budget?.replace(/,/g, '')),
        deliveryDate: formData?.deliveryDate,
        carrierFee: parseInt(formData?.carrierFee?.replace(/,/g, '')),
        notes: formData?.notes,
        status: 'active'
      };

      await purchaseRequestsService?.create(newRequest);
      onRefresh();
    } catch (error) {
      console.error('Create request error:', error);
    }
  };

  const handleViewOffers = (requestId) => {
    setSelectedRequestId(requestId);
    const requestOffers = data?.offers?.filter((offer) => offer?.requestId === requestId);
    if (requestOffers?.length > 0) {
      window.scrollTo({ top: document.getElementById('offers-section')?.offsetTop - 100, behavior: 'smooth' });
    }
  };

  const handleAcceptOffer = async (offerId) => {
    try {
      const offer = data?.offers?.find((o) => o?.id === offerId);
      if (offer) {
        const deal = await offersService?.acceptOffer(
          offerId,
          user?.id,
          offer?.travelerId,
          offer?.requestId
        );
        
        if (deal) {
          onRefresh();
          navigate('/deal-room-page', { state: { dealId: deal?.id } });
        }
      }
    } catch (error) {
      console.error('Accept offer error:', error);
    }
  };

  const handleDeclineOffer = async (offerId) => {
    try {
      await offersService?.declineOffer(offerId);
      onRefresh();
    } catch (error) {
      console.error('Decline offer error:', error);
    }
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const filteredRequests = data?.requests?.filter((request) => {
    if (filters?.status && request?.status !== filters?.status) return false;
    if (filters?.category && request?.category !== filters?.category) return false;
    if (filters?.destination && request?.destinationCountry !== filters?.destination) return false;
    return true;
  });

  const displayedOffers = selectedRequestId
    ? data?.offers?.filter((offer) => offer?.requestId === selectedRequestId)
    : data?.offers;

  return (
    <div className="space-y-6 md:space-y-8">
      <CreateRequestForm onSubmit={handleCreateRequest} currentLanguage={currentLanguage} />
      <FilterBar filters={filters} onFilterChange={handleFilterChange} currentLanguage={currentLanguage} />
      <RequestsTable requests={filteredRequests} onViewOffers={handleViewOffers} currentLanguage={currentLanguage} />
      <div id="offers-section">
        <OffersPanel
          offers={displayedOffers}
          onAccept={handleAcceptOffer}
          onDecline={handleDeclineOffer}
          currentLanguage={currentLanguage}
        />
      </div>
    </div>
  );
};

export default BuyerMode;